import { List } from 'immutable';
import { ensure } from '../../../utils/arrayUtils';
import LanguageUtils from '../../../utils/LanguageUtils';
import ValidationModel from '../../../utils/validationModel';
import ValidationUtils, { ValidationConfig } from '../../../utils/validationUtils';
import CustomerCancellationRuleSet from '../../../interfaces/output/customerCancellationRuleSet';

const messages = {
    alertLimitExceeded: LanguageUtils.createMessage('Validation error text'),
    requiredFields: LanguageUtils.createMessage('Validation error general'),
    invalidDates: LanguageUtils.createMessage('Invalid date range'),
    invalidDateFormat: LanguageUtils.createMessage('Invalid date format')
};

export default class CustomerCancellationRuleSetPriorityAndValidityValidation extends ValidationUtils {
    static validateInputString(inputString?: string, options?: ValidationConfig): boolean {
        return this.validateInputStringLength(inputString, options);
    }

    static validateForm(customerCancellationRuleSet: CustomerCancellationRuleSet): ValidationModel {
        const validationModel = { validationMessages: List() } as ValidationModel;

        const requiredFields =
        this.validateInputString(customerCancellationRuleSet?.customer?.name) &&
        this.validateInputString(customerCancellationRuleSet.id?.toString());

        if(!requiredFields) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.requiredFields);
        }

        return validationModel;
        
    }

    static validateRequiredDate(inputDate: Date | undefined): boolean {
        return !!inputDate;
    }

    static validateInputDateStart(customerCancellationRuleSet: CustomerCancellationRuleSet): boolean {
        const dateStart = customerCancellationRuleSet.validFromDate;
        const dateTo = customerCancellationRuleSet.validToDate;
        
        return this.validateDateTimeRangeStart(dateStart, dateTo);
    }

    static validateInputDateEnd(customerCancellationRuleSet: CustomerCancellationRuleSet): boolean {
        const dateStart = customerCancellationRuleSet.validFromDate;
        const dateTo = customerCancellationRuleSet.validToDate;
        
        return this.validateDateTimeRangeTo(dateStart, dateTo);
    }

    static validateCustomerCancellationRuleSetForm(customerCancellationRuleSet: CustomerCancellationRuleSet): ValidationModel {
        const validationModel = {
            validationMessages: List(),
            isValid: true
        } as ValidationModel;
        const {
            priorityRank,
            validFromDate,
            validToDate
        } = customerCancellationRuleSet;

        const requiredFields =
        this.validateInputString(priorityRank?.toString()) &&
        this.validateRequiredDate(validFromDate);

        if(!requiredFields) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.requiredFields);
        }

        const endDate = customerCancellationRuleSet.validToDate;
        const validDates = endDate ? this.validateInputDateStart(customerCancellationRuleSet) &&
        this.validateInputDateEnd(customerCancellationRuleSet) : true;

        if(!validDates) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.invalidDates);
        }

        const formatedDate = this.validateDateFormat(validFromDate) &&
        this.validateDateFormat(validToDate);

        if(!formatedDate) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.invalidDateFormat);
        }

        return validationModel;
    }
}
